var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-switch", style: _vm.customStyles },
    [
      _c("v-typo", {
        staticClass: "lang-switch__headline",
        attrs: { variant: "h1" },
        domProps: { innerHTML: _vm._s(_vm.$t("language.headline")) }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "lang-switch__list" },
        _vm._l(_vm.availableLocales, function(locale) {
          return _c(
            "li",
            { key: "locale-toggle-" + locale, staticClass: "lang-switch__li" },
            [
              _c(
                "a",
                {
                  staticClass: "lang-switch__item",
                  on: {
                    click: function() {
                      return _vm.changeLocale(locale)
                    }
                  }
                },
                [
                  _c("v-image", {
                    staticClass: "lang-switch__icon",
                    attrs: { alt: locale, tiny: _vm.language(locale) }
                  }),
                  _vm._v(" "),
                  _c("v-typo", {
                    staticClass: "lang-switch__label",
                    attrs: { variant: "body-perex" },
                    domProps: { innerHTML: _vm._s(locale.toUpperCase()) }
                  })
                ],
                1
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }